import { RecipeListQuery } from '@diamond/shared/types';
import {
  infiniteQueryOptions,
  queryOptions,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';

import { getRecipeList, getRecipeSection } from '../queries/recipe';
import { useAuthStore, useShipToStore } from '../stores';

export const RECIPE_QUERY_KEY = 'Recipe';

type InfiniteRecipeListQuery = Omit<Partial<RecipeListQuery>, 'page'>;

function infiniteRecipeListQueryOptions(
  token: string | null,
  params?: InfiniteRecipeListQuery
) {
  return infiniteQueryOptions({
    queryKey: [RECIPE_QUERY_KEY, params],
    queryFn: ({ pageParam }) =>
      getRecipeList(token, {
        page: pageParam,
        size: params?.size || 25,
        ...params,
      }),
    initialPageParam: 1,
    getNextPageParam: ({ nextPage }) => nextPage,
  });
}

export function useGetInfiniteRecipeList(params?: InfiniteRecipeListQuery) {
  const token = useAuthStore((s) => s.access_token);
  const warehouse = useShipToStore((s) => s.selectedShipToId);
  const resolvedWarehouse = token && warehouse ? warehouse : undefined;
  return useInfiniteQuery(
    infiniteRecipeListQueryOptions(token, {
      ...params,
      warehouse: resolvedWarehouse,
    })
  );
}

function recipeListSectionQueryOptions(token: string | null) {
  return queryOptions({
    queryKey: [RECIPE_QUERY_KEY, 'section'],
    queryFn: () => getRecipeSection(token),
  });
}

export function useGetRecipeListSection() {
  const token = useAuthStore((s) => s.access_token);
  return useQuery(recipeListSectionQueryOptions(token));
}
